import { PageProps, graphql, useStaticQuery } from 'gatsby';
import React, { useEffect } from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import { StructuredSchemaData } from '../components/structuredSchemaData';
import { useAnalytics } from '../shared/analytics';
import { headerSlantContainerNoContent } from '../shared/styles/headerSlantContainer';
import { FaqList } from '../templates/faq/faqList';

export default function Faqs() {
    // const theme = useTheme()
    // const isLargeMobile = useMediaQuery(theme.breakpoints.down("lg"))

    // const NotPrintable = styled('div')(notPrintable);
    const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();

    const analytics = useAnalytics();
    useEffect(() => {
        analytics.trackPageView(AnalyticsPageType.page);
    }, [])

    return (
        <>
            <HorizontalSlantContainer id={"faqs"} autoHeight>
                <Container sx={headerSlantContainerNoContentStyles}></Container>
            </HorizontalSlantContainer>

            <Container sx={{ pt: 6 }}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h1" gutterBottom>
                            Frequently Asked Questions
                        </Typography>
                    </Box>

                    <FaqList />
                </Stack>
            </Container>
        </>
    )
}
export const Head = (props: PageProps) => {
    const query: Queries.FaqStructuredDataListQuery = useStaticQuery(graphql`
    query FaqStructuredDataList {  
      faqList: contentfulFaqList {
        items {
          questionText: title
          answerText: content {
            raw
          }
        }
      }
    }
  `)

    const structuredData = query.faqList.items.map((faq) => {
        return {
            itemType: 'ContentfulStructuredSchemaFaqItem',
            questionText: faq.questionText,
            answerText: faq.answerText.raw
        }

    })

    return (
        <SeoHead
            title="FAQs"
            pathname={props.location.pathname}
            description="Frequently Asked Questions on Methylene Blue"
        >
            <StructuredSchemaData staticItems={structuredData} />
        </SeoHead>
    )
}
